import React, { Component } from 'react';
import { Doughnut } from 'react-chartjs-2';

class DoughnutChartPacsSummary extends Component {
  getDataset() {
    const { pacs = [] } = this.props;

    const labels = Object.keys(pacs);
    const data = Object.values(pacs);

    return {
      labels: labels,
      datasets: [
        {
          label: 'Consumo',
          backgroundColor: [
            'rgba(75,192,192,0.4)',
            'rgba(255, 99, 132, 0.2)',
            'rgba(255, 206, 86, 0.2)',
            'rgba(60, 179, 113, 0.2)',
          ],
          borderColor: [
            'rgba(75,192,192,1)',
            'rgba(255, 99, 132, 1)',
            'rgba(255, 206, 86, 1)',
            'rgba(60, 179, 113, 1)',
          ],
          borderWidth: 1,
          data: data,
        },
      ],
    };
  }

  render() {
    const data = this.getDataset();

    return (
      <Doughnut
        height={100}
        data={data}
      />
    );
  }
}

export default DoughnutChartPacsSummary;
